import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../components/ui/Button';
import CinematicText from '../../components/ui/CinematicText';
import GlowingPortal from '../../components/ui/GlowingPortal';

const Hero = () => {
  return (
    <section className="relative min-h-[100svh] flex items-center justify-center overflow-hidden pt-20">
      {/* Parallax Background */}
      <motion.div
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 18, ease: "easeOut" }}
        className="absolute inset-0 z-0"
      >
        <img
          src="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/5e962f4e81ed25550f0f4cdc2d6861b4.png"
          alt="Jennifer Gräser"
          className="w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-dark/70 to-dark" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_30%,rgba(212,175,55,0.08)_0%,transparent_65%)]" />
        {/* Film grain */}
        <div className="absolute inset-0 opacity-[0.025]"
          style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.85\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")', backgroundSize: '200px' }} />
      </motion.div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col items-center">
        {/* Eyebrow */}
        <motion.p
          initial={{ opacity: 0, letterSpacing: "0.05em" }}
          animate={{ opacity: 1, letterSpacing: "0.35em" }}
          transition={{ duration: 2, delay: 0.2 }}
          className="text-gold uppercase text-xs md:text-sm mb-10 font-semibold"
          style={{ textShadow: '0 0 20px rgba(212,175,55,0.7)' }}
        >
          Diese Seite ist kein Zufall. Sie ist Dein Zeichen.
        </motion.p>

        {/* Headline with SplitText reveal */}
        <div className="text-5xl md:text-7xl lg:text-8xl font-serif text-cream leading-[1.1] mb-8 w-full">
          <CinematicText text="Dein nächstes Kapitel" delay={0.6} className="justify-center mb-3" />

          {/* Glowing Portals Line */}
          <div className="flex flex-wrap justify-center items-center gap-x-4 mt-2">
            <motion.span initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 1.4 }}>
              voller
            </motion.span>
            <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 1.7 }}>
              <GlowingPortal to="/beziehungsheilung-fuer-frauen">Liebe</GlowingPortal>
            </motion.span>
            <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 1.9 }}>
              &
            </motion.span>
            <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 2.1 }}>
              <GlowingPortal to="/female-leadership-fuer-frauen">Fülle</GlowingPortal>
            </motion.span>
          </div>
          <CinematicText text="beginnt hier." delay={2.3} className="justify-center mt-3" />
        </div>

        {/* Sub-copy */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, delay: 3 }}
          className="text-lg md:text-xl text-cream/75 max-w-2xl mx-auto mb-14 font-light leading-relaxed"
        >
          Du spürst, dass Du für mehr bestimmt bist. Lass das alte{' '}
          <GlowingPortal to="/female-leadership-fuer-frauen">Leistungsdenken</GlowingPortal> los und trete ein in eine Welt, in der{' '}
          <GlowingPortal to="/female-leadership-fuer-frauen">Erfolg</GlowingPortal>,{' '}
          <GlowingPortal to="/beziehungsheilung-fuer-frauen">tiefe Verbundenheit</GlowingPortal> und Leichtigkeit Dein neuer Standard sind.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 3.3 }}
          className="flex flex-col sm:flex-row gap-6 justify-center items-center w-full"
        >
          <Button variant="gold" className="w-full sm:w-auto">Jetzt GlücksCall buchen</Button>
          <Button variant="outline" className="w-full sm:w-auto">Programme entdecken</Button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        animate={{ y: [0, 14, 0], opacity: [0.2, 1, 0.2] }}
        transition={{ repeat: Infinity, duration: 3.5, ease: "easeInOut" }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <div className="w-1 h-1 rounded-full bg-gold" style={{ boxShadow: '0 0 12px rgba(212,175,55,1)' }} />
        <div className="w-[1px] h-20 bg-gradient-to-b from-gold via-gold/40 to-transparent" />
      </motion.div>
    </section>
  );
};

export default Hero;